import { RenderHtml } from '../../../utils';
import { componentViewerTranslate } from '../../translations';
import * as React from 'react';
export class StepByStepComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visibleStepIndex: 0
        };
        this.buttonRef = (elem) => {
            if (elem) {
                elem.addEventListener('click', (_) => {
                    if (document.activeElement && document.activeElement.blur) {
                        document.activeElement.blur();
                    }
                });
            }
        };
    }
    showNextStep() {
        const componentValue = this.props.value;
        const maxIndex = componentValue.steps.length - 1;
        const possibleNextStepIndex = this.state.visibleStepIndex + 1 > maxIndex ? 0 : this.state.visibleStepIndex + 1;
        const visibleStepIndex = componentValue.allowCircular ? possibleNextStepIndex : this.state.visibleStepIndex;
        this.setState({ visibleStepIndex });
    }
    showPreviousStep() {
        const componentValue = this.props.value;
        const minIndex = 0;
        const currentIndex = this.state.visibleStepIndex;
        const stepsCount = componentValue.steps.length;
        const possiblePreviousStepIndex = currentIndex - 1 < minIndex ? stepsCount - 1 : currentIndex - 1;
        const visibleStepIndex = componentValue.allowCircular ? possiblePreviousStepIndex : this.state.visibleStepIndex;
        this.setState({ visibleStepIndex });
    }
    renderStep(step) {
        const stepImageCss = {
            backgroundImage: `url(${step.image.src})`
        };
        const stepImage = React.createElement("div", { className: 'step-image', style: stepImageCss });
        const maybeLinkedImage = step.image.link ? React.createElement("a", { href: step.image.link, target: '_blank' }, stepImage) : stepImage;
        const totalStepsCount = `${this.props.value.steps.length}`;
        const currentStepNumber = `${this.state.visibleStepIndex + 1}`;
        const translate = componentViewerTranslate(this.props.locale);
        const stepCountTitle = translate(`components.step-by-step.step-count`, {
            step: currentStepNumber,
            totalSteps: totalStepsCount
        });
        return (React.createElement("div", { className: `step-content ${this.props.value.layout}` },
            React.createElement("div", { tabIndex: 0, ref: this.buttonRef, className: 'step-text-wrapper' },
                React.createElement("div", { className: 'step-count-title' },
                    React.createElement(RenderHtml, { html: stepCountTitle })),
                React.createElement("h4", { className: 'step-title' }, step.title),
                React.createElement("div", { className: 'step-description' },
                    React.createElement(RenderHtml, { html: step.html, className: 'rendered-html' }))),
            maybeLinkedImage));
    }
    render() {
        const props = this.props;
        const onClickPreviousStep = () => this.showPreviousStep();
        const onClickNextStep = () => this.showNextStep();
        return (React.createElement("div", { className: 'component step-by-step-component', "data-component-type": 'step-by-step' },
            React.createElement("div", { className: `step-by-step-component-wrapper ${props.value.layout}` },
                React.createElement("div", { className: 'pagination-button-wrapper previous', onClick: onClickPreviousStep },
                    React.createElement("button", { ref: this.buttonRef, className: 'arrow previous-step' })),
                React.createElement("div", { className: 'current-step', "data-component-step": this.state.visibleStepIndex + 1 }, this.renderStep(this.props.value.steps[this.state.visibleStepIndex])),
                React.createElement("div", { className: 'pagination-button-wrapper next', onClick: onClickNextStep },
                    React.createElement("button", { ref: this.buttonRef, className: 'arrow next-step' })))));
    }
}
